import { FC, useState } from "react";
import { useBetween } from "use-between";
import { Button } from "../../../utils/Button";
import { propsInterfaceFormGroupInput } from "../../../utils/form/FormGroupInput";
import { BTCreateContract4 } from "../BTContract/BTCreateContract4";
import { ModalForm } from "../../../utils/modal/ModalForm";
import { AlertModal } from "../../../utils/modal/AlertModal";

const ActionDataGrid4: FC<actionDataGridProps> = (props) => {
    const [showModalMenu4, setShowModalMenu4] = useState(false);
    const [showConfirm4, setShowConfirm4] = useState(false);
    const { deleteRow4, dataModelo4, setDataModelo4, addRowStructure4,updateRow4 } = useBetween(BTCreateContract4);
    const columInput=3;
    const [arrayInput4] = useState<propsInterfaceFormGroupInput[]>([
        {
            columInput: columInput,
            campo: "fatherStructure3",
            label: "Estructura Padre",
            type: "autocomplete",
            advanceOptions: {
                id: "fatherStructure3",
                multiple: false,
                placeholder: "Ingrese Estructura",
                options: [
                    { text: "", value: "1" },
                    { text: "Entrada", value: "2" },
                    { text: "Postre", value: "3" },
                    { text: "Acompañamiento", value: "4" }
                ]
            },
            onChange: (item: any) => {
            },
            className: "form-control form-control-lg step-2  input-contract"
        },
        {
            columInput: columInput,
            campo: "mainIngredients2",
            label: "Ingredientes Principales",
            type: "autocomplete",
            advanceOptions: {
                id: "mainIngredients2",
                placeholder: "Ingrese Ingredientes",
                multiple: false,
                options: [
                    { text: "Pollo Entero", value: "1" },
                    { text: "Vacuno Entero", value: "2" },
                    { text: "Papas", value: "3" },
                    { text: "Arroz", value: "4" }
                ]
            },
            className: "form-control form-control-lg input-contract"
        },
        {
            columInput: columInput,
            campo: "frequency",
            type: "number",
            label: "Frecuencia",
            placeholder: "Ingrese frecuencia"
        }
    ])
    return (
        <>
            {/* <Button
                className="btn-table"
                type="button"
                onClick={() => {
                    addRowStructure4(props)
                    setShowModalMenu4(true)
                }}
            ><i className="bi bi-pencil-square icon-action"></i>
            </Button> */}
            <Button
                className="btn-table"
                onClick={() => {
                    setShowConfirm4(true);
                }}
                type="button"
            ><i className="bi bi-trash3-fill icon-action"></i>
            </Button>
            {/* {
                showModalMenu4
                &&
                <ModalForm
                    initialValues={dataModelo4}
                    show={showModalMenu4}
                    onSubmit={(_value, formikProps) => {
                        setTimeout(() => {
                            setDataModelo4(props.dataRow)
                            updateRow4(formikProps.values)
                            setShowModalMenu4(false)
                        }, 500);
                    }}
                    close={() => {
                        setShowModalMenu4(false)
                    }}
                    save={() => {
                        
                    }}
                    title={"Editar estructura contrato"}
                    arrayInput={arrayInput4}
                />
            } */}
            {
                showConfirm4
                &&
                <AlertModal
                    title={"Alerta"}
                    message={"¿Esta seguro de eliminar?"}
                    save={() => {
                        deleteRow4(props)
                        setShowConfirm4(false)
                    }}
                    saveName="Eliminar"
                    show={showConfirm4}
                    close={()=>{
                        setShowConfirm4(false)
                    }}
                />
            }
        </>
    )
}
interface actionDataGridProps {
    edit?(): void,
    delete?(): void,
    dataRow?: any
}
export { ActionDataGrid4 }